import { compose, flatten, is, map, mapObjIndexed } from 'ramda'
import { v4 as uuidv4 } from 'uuid'

export const mapReferences = obj => {
  let refs = []
  mapObjIndexed((value, key) => {
    if (is(Object, value)) refs = [...refs, ...mapReferences(value)]
    if (is(Array, value)) refs = [...refs, ...compose(flatten, map(mapReferences))(value)]
    if (key === 'reference') refs = [...refs, value]
  }, obj)
  return refs
}

const replaceAllReferences = (object, references = []) => {
  if (!object) return object

  let objectStr = JSON.stringify(object)

  references.forEach(reference => {
    objectStr = objectStr?.replaceAll(reference, uuidv4())
  })

  return JSON.parse(objectStr)
}

export default replaceAllReferences
